import React, {useState} from "react"
import InputText from "../../../../Shared/FormComponents/InputText";
import InputButton from "../../../../Shared/FormComponents/InputButton";
import { useHistory } from "react-router-dom";
import Form from '../../../../Shared/Form';
import { stripUsernameChars } from '../../../../Shared/StringManipulation';
import { createAccount, getValidAccountNumber } from "../../../../../lib/api/user";
import * as Yup from 'yup';

const CreateForm = () => {
    const history = useHistory();
    const [loading, setLoading] = useState();
    const [success, setSuccess] = useState()
    
    const submit = ({ account, email }, { setErrors, setStatus }) => {
        console.log('running create function for account:', account, ' email:', email);
        setLoading(true);
        const validAccountNumber = getValidAccountNumber(account);
        createAccount(validAccountNumber, email)
            .then(resp => {
                console.log('success', resp);
                setLoading(false);
                setSuccess(true);
                setTimeout(()=>history.push('/login/check-email'), 1000)
            })
            .catch(err =>
            {
                console.log('err', err)
                setLoading(false);
                setSuccess(false);
                if (err.formStatus == "UserAlreadyExists") {
                    setStatus(`You have already registered for this account, please log in <a class='underline' href='/login'>here</a>`)
                } else if (err.formStatus == "ContactNotVerified") {
                    setStatus("Contact not found! Please check provided data")
                } else if (err.formStatus == "SignupNotProcessed") {
                    setStatus("Signup could not be processed. Please try again or contact support if the issue persists!")
                } else {
                    setStatus(err.formStatus)
                };
            })
    }

    return (
        <Form
            onSubmit={submit}
            className="grid grid-cols-1 gap-y-24px justify-items-center"
            validationSchema={formSchema}
        >
            {({values, setFieldValue, errors, handleSubmit, handleChange}) => (
                <>
                    <InputText
                        className="w-full rounded-28px"
                        id="account"
                        error={errors && errors.account}
                        label="Account number"
                        placeholder="e.g. EFW000000-00 or EFX000000"
                        tick={success}
                        value={values.account}
                        onChange={ev => stripUsernameChars(ev.target.value, val => setFieldValue('account', val))}
                    />
                    <InputText
                        className="w-full rounded-28px"
                        id="email"
                        error={errors && errors.email}
                        label="Email address"
                        placeholder="e.g. user@everflow.com"
                        tick={success}
                        value={values.email}
                        onChange={ev => setFieldValue('email', ev.target.value)}
                    />
                    <InputButton
                        loading={loading}
                        className="w-full"
                        onClick={handleSubmit}
                        label="Create account"
                    />
                </>
            )}

        
        </Form>
    )
}

const formSchema = Yup.object().shape({
    account: Yup.string().required('Please enter your account number'),
    email: Yup.string().email('Please enter correct email address').required('Please enter your email address')
})

export default CreateForm
